module.exports = __webpack_public_path__ + "static/scale-model-of-bones-prostudios-in-worcester-massachusetts-3e2957dd323e6f1e8d1e1bff4b1112fe.png";